import React, { useState } from "react";
import Pill from "../common/Pill";
const ContactForHelp = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    email: "",
    phone: "",
    message: "",
  });
  const [status, setStatus] = useState({
    submitting: false,
    succeeded: false,
    error: null,
  });
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ submitting: true, succeeded: false, error: null });
    const FORM_ENDPOINT = "https://formspree.io/f/mpwvyaqe";
    try {
      const response = await fetch(FORM_ENDPOINT, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        setStatus({ submitting: false, succeeded: true, error: null });
        setFormData({ firstName: "", email: "", phone: "", message: "" });
      } else {
        const data = await response.json();
        if (Object.hasOwn(data, "errors")) {
          setStatus({
            submitting: false,
            succeeded: false,
            error: data.errors.map((err) => err.message).join(", "),
          });
        } else {
          setStatus({
            submitting: false,
            succeeded: false,
            error: "There was a problem submitting your form",
          });
        }
      }
    } catch (error) {
      setStatus({
        submitting: false,
        succeeded: false,
        error: "There was a network error. Please try again.",
      });
    }
  };

  if (status.succeeded) {
    return (
      <div className="flex items-center justify-center p-4 sm:p-6 lg:p-8">
        <div className="w-full max-w-6xl bg-orange-50 rounded-3xl p-8 sm:p-12">
          <div className="text-center py-20">
            <div className="w-16 h-16 bg-green-100 text-green-600 rounded-full flex items-center justify-center mx-auto mb-6">
              <svg
                className="w-8 h-8"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <h2 className="text-3xl font-bold text-gray-900 mb-4">
              Message Sent!
            </h2>
            <p className="text-gray-600 text-lg">
              Thanks for reaching out. We will get back to you within 24 hours.
            </p>
            <button
              onClick={() => setStatus({ ...status, succeeded: false })}
              className="mt-8 text-red-600 font-medium hover:underline"
            >
              Send another message
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center p-4 sm:p-6 lg:p-8">
   <div className="max-w-6xl px-4 mx-auto">
       <div className="text-center mb-16 ">
        <div className="flex justify-center mb-6">
          <Pill text="still have questions?" backgroundColor="#FFECEC" />
        </div>
        <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold mb-4 leading-snug">
          We'd love to hear from you
        </h2>
        <p className="text-gray-400">
         We care about you and ready to listen any problem you might have. 
        </p>
      </div>
      <div className=" bg-orange-50 rounded-3xl p-8 sm:p-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
          <div className="flex flex-col justify-between">
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-4 leading-tight">
                Tell us about your project
              </h2>

              <div className="space-y-4 mb-12">
                <div className="flex items-start gap-3">
                  <div className="flex-shrink-0 w-5 h-5 bg-red-600 rounded-full flex items-center justify-center mt-0.5">
                    <svg
                      className="w-3 h-3 text-white"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="3"
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  </div>
                  <p className="text-gray-700 text-base">
                    Tell us about your business and find ways Voice AI can be useful for you 
                  </p>
                </div>

                <div className="flex items-start gap-3">
                  <div className="flex-shrink-0 w-5 h-5 bg-red-600 rounded-full flex items-center justify-center mt-0.5">
                    <svg
                      className="w-3 h-3 text-white"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="3"
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  </div>
                  <p className="text-gray-700 text-base">
                    Have ideas on how to improve our product? Please share your thoughts!
                  </p>
                </div>

                <div className="flex items-start gap-3">
                  <div className="flex-shrink-0 w-5 h-5 bg-red-600 rounded-full flex items-center justify-center mt-0.5">
                    <svg
                      className="w-3 h-3 text-white"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="3"
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  </div>
                  <p className="text-gray-700 text-base">
                    Your message is important. We'll get back to you personally.
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-8 lg:mt-0">
              <a
                href="mailto:info@agoravoice.ai"
                className="text-red-600 text-base font-medium hover:underline block mb-6"
              >
                info@agoravoice.ai
              </a>

              <p className="text-gray-700 text-base mb-2">
                Always busy and want to book
              </p>
              <p className="text-gray-700 text-base mb-6">
                an exact time to call?
              </p>
              <a
                href="https://calendar.app.google/52NGENgV6EnH1RKR9"
                target="_blank"
                rel="noopener noreferrer"
                className="px-6 py-2.5 border bg-white border-gray-500 text-gray-900 rounded-full font-medium hover:bg-gray-900 hover:text-white transition-colors text-sm inline-block"
              >
                Book A Free Call
              </a>
            
            </div>
          </div>
          <div className="bg-white border border-gray-500 rounded-2xl p-6">
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <input
                  type="text"
                  name="firstName"
                  placeholder="Your first name"
                  value={formData.firstName}
                  onChange={handleChange}
                  className="w-full px-6 py-4 bg-black/5 rounded-xl text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-red-600 text-base"
                  required
                />
              </div>

              <div>
                <input
                  type="email"
                  name="email"
                  placeholder="Your email address"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full px-6 py-4 bg-black/5 rounded-xl text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-red-600 text-base"
                  required
                />
              </div>

              <div>
                <input
                  type="tel"
                  name="phone"
                  placeholder="Your phone number (optional)"
                  value={formData.phone}
                  onChange={handleChange}
                  className="w-full px-6 py-4 bg-black/5 rounded-xl text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-red-600 text-base"
                />
              </div>

              <div>
                <textarea
                  name="message"
                  placeholder="Your message"
                  value={formData.message}
                  onChange={handleChange}
                  rows="6"
                  className="w-full px-6 py-4 bg-black/5 rounded-xl text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-red-600 resize-none text-base"
                  required
                ></textarea>
              </div>

              {status.error && (
                <div className="p-3 bg-red-50 text-red-600 rounded-lg text-sm">
                  {status.error}
                </div>
              )}

              <div className="flex justify-end pt-2">
                <button
                  type="submit"
                  disabled={status.submitting}
                  className="px-10 w-full md:w-auto py-2 hover:from-[#B22222] hover:to-[#B22222] bg-gradient-to-r from-[#B22222] to-[#FF4D4D] font-semibold border border-gray-400 text-white rounded-full hover:bg-red-700 transition-colors text-base shadow-lg disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {status.submitting ? "Sending..." : "Submit"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
   </div>
    </div>
  );
};

export default ContactForHelp;
